/** Roles that perform field work and need job/work-order GPS */
export const FIELD_TEAM_ROLES = [
  'HOUSEKEEPER',
  'MAINTENANCE',
  'INSPECTOR',
  'HOUSEKEEPER_MANAGER',
  'PROPERTY_MANAGER',
];

export const LOCATION_PROMPT_SESSION_KEY = 'location-permission-requested';

export const getLocationPromptDismissedKey = (userId) =>
  `location-tracking-prompt-${userId}-dismissed`;

export const getLocationPromptEnabledKey = (userId) =>
  `location-tracking-prompt-${userId}-enabled`;

export const isFieldTeamRole = (role) => FIELD_TEAM_ROLES.includes(role);
